import { render, staticRenderFns } from "./Redcollege.vue?vue&type=template&id=4223b88a&"
import script from "./Redcollege.vue?vue&type=script&lang=js&"
export * from "./Redcollege.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports